export default __webpack_public_path__ + "static/chumbador-medidas-5d27702db86aa28818c7e9647d9d3210.png";